import { render, staticRenderFns } from "./QuestionMCItem.vue?vue&type=template&id=0bcc23ae&scoped=true&"
import script from "./QuestionMCItem.vue?vue&type=script&lang=js&"
export * from "./QuestionMCItem.vue?vue&type=script&lang=js&"
import style0 from "./QuestionMCItem.vue?vue&type=style&index=0&id=0bcc23ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bcc23ae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VCheckbox,VRadio,VRadioGroup})
